import React from 'react';
import { connect } from 'react-redux';
import {
  Route,
  Redirect,
} from 'react-router-dom';
import PropTypes from 'prop-types';

const props = state => ({ isLoggedIn: state.auth.isLoggedIn });

const _PrivateRoute = ({ component: Component, ...rest }) => {

  return (<Route {...rest} render={(props) => {
    return (rest.isLoggedIn === true
      ? <Component {...props} />
      : <Redirect to='/login' />
    );
  }} />);
};

const _PublicRoute = ({ component: Component, ...rest }) => {
  return (<Route {...rest} render={(props) => (
    rest.isLoggedIn === true && rest.restricted
      ? <Redirect to='/contracts' />
      : <Component {...props} />
  )} />);
};

_PrivateRoute.propTypes = {
  component: PropTypes.object.isRequired,
};

_PublicRoute.propTypes = {
  component: PropTypes.object.isRequired,
};

export const PrivateRoute = connect(props, null)(_PrivateRoute);
export const PublicRoute = connect(props, null)(_PublicRoute);